import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import useUser from '@/hooks/useUser';
import FavoriteIdeaListItem from '@/components/favorites/FavoriteIdeaListItem';
import { favoritePost } from '@/domains/firestore/user';
import { IIdea } from '@/@types/generated/contentful';

type ComponentProps = {
  idea: IIdea;
};

const FavoriteIdeaListItemContainer: React.FC<ComponentProps> = ({ idea }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useUser();
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      setLoading(true);
      try {
        if (user) {
          await favoritePost({ userId: user.uid, postId });
          await dispatch(updateUser(user.uid));
        }
      } catch {
        // noop
      } finally {
        setLoading(false);
      }
    },
    [dispatch, user]
  );

  return (
    <FavoriteIdeaListItem
      idea={idea}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      invalid={isLoading}
    />
  );
};

export default FavoriteIdeaListItemContainer;
